<template>
	<layer class="opt_more_g" name="headCont">
		<div class="box_opt_menu head_cont_type">
			<div class="menu_item" v-for="headCont in headConts">
				<a href="javascript:" class="link_menu" @click="callback(headCont)">{{ headCont }}</a>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';

export default {
	components: {Layer},
	props: {
		headConts: {
			type: Array,
			default: () => ([])
		},
		callback: {
			type: Function,
			default: () => null
		}
	}
}
</script>
